import React from 'react';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '3rem 1.5rem' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Termos de Uso</h1>
      <p style={{ color: 'var(--dark-light)', marginBottom: '2rem', fontSize: '0.9rem' }}>
        Última atualização: Abril de 2026
      </p>

      <div style={{ lineHeight: 1.8, color: 'var(--dark)', fontSize: '0.95rem' }}>

        {/* ── IMPORTANT LEGAL NOTICE BANNER ── */}
        <div style={{
          background: 'rgba(255, 193, 7, 0.1)',
          border: '2px solid rgba(255, 193, 7, 0.4)',
          borderRadius: '12px',
          padding: '1.25rem 1.5rem',
          marginBottom: '2rem',
          fontSize: '0.92rem',
          lineHeight: 1.7,
        }}>
          <strong style={{ display: 'block', marginBottom: '0.5rem', color: '#b8860b', fontSize: '1rem' }}>
            ⚠️ Aviso Legal Importante
          </strong>
          A RifaMaker é uma <strong>plataforma tecnológica</strong> desenvolvida para possibilitar a criação de
          ações entre amigos, campanhas de arrecadação com fins beneficentes ou para suportar causas sem fins
          lucrativos. A RifaMaker <strong>não é uma plataforma de jogos de azar</strong> e <strong>não organiza,
          gere ou promove sorteios, rifas ou loterias</strong>. A responsabilidade pelo cumprimento de todas as
          leis e regulamentações aplicáveis é exclusivamente do usuário organizador da campanha.
        </div>

        <Section title="1. Aceitação dos Termos">
          Ao acessar ou utilizar a plataforma RifaMaker ("Plataforma"), você concorda em cumprir e estar
          vinculado a estes Termos de Uso ("Termos"). Se você não concordar com qualquer disposição destes
          Termos, não utilize a Plataforma. O uso continuado da Plataforma após publicação de alterações
          constitui aceitação dos novos Termos.
        </Section>

        <Section title="2. Definições">
          <strong>Plataforma</strong>: o site, aplicativo e serviços tecnológicos fornecidos pela RifaMaker.{' '}
          <strong>Organizador</strong>: o usuário que cria uma campanha de ação entre amigos na Plataforma.{' '}
          <strong>Participante</strong>: o usuário que adquire cotas/bilhetes em uma campanha.{' '}
          <strong>Campanha</strong>: a ação entre amigos, campanha beneficente ou arrecadação criada pelo
          Organizador na Plataforma.{' '}
          <strong>Ação entre amigos</strong>: modalidade de arrecadação coletiva informal entre pessoas
          conhecidas, sem fins lucrativos, de caráter beneficente ou social.
        </Section>

        <Section title="3. Natureza do Serviço">
          A RifaMaker é uma <strong>plataforma tecnológica</strong> desenvolvida exclusivamente para
          possibilitar a criação de ações entre amigos, campanhas de arrecadação com fins beneficentes
          ou para suportar causas sem fins lucrativos. A Plataforma oferece exclusivamente serviços de
          software para facilitar a interação entre seus usuários. Os Serviços <strong>não abrangem</strong> a
          oferta ou venda de títulos mobiliários; a Plataforma <strong>não atua como corretora de valores</strong> e{' '}
          <strong>não promove, incentiva ou organiza sorteios, rifas ou loterias</strong>. A RifaMaker não
          organiza nem gere campanhas. A responsabilidade pela criação e gestão das campanhas é exclusivamente
          dos Organizadores, não cabendo à Plataforma requerer eventuais autorizações que o Organizador entender
          necessárias às especificidades de sua campanha.
        </Section>

        <Section title="4. Cadastro e Conta do Usuário">
          Para criar campanhas, é necessário criar uma conta fornecendo informações verdadeiras, completas e
          atualizadas. O Organizador declara ter pelo menos 18 (dezoito) anos de idade e possuir capacidade
          civil plena. Você é responsável pela segurança de sua conta, senha e por todas as atividades
          realizadas sob sua conta. A participação em campanhas pode ser feita utilizando um endereço de e-mail
          válido. A RifaMaker se reserva o direito de suspender ou encerrar contas que violem estes Termos,
          sem necessidade de aviso prévio.
        </Section>

        <Section title="5. Responsabilidades do Organizador">
          Ao criar uma campanha na Plataforma, o Organizador declara e garante que:{' '}
          <strong>(a)</strong> possui capacidade legal para criar a campanha;{' '}
          <strong>(b)</strong> é o único responsável por verificar a conformidade de sua campanha com todas as
          leis e regulamentações aplicáveis em sua jurisdição, incluindo, sem limitação, a legislação sobre
          sorteios, rifas, promoções comerciais, jogos de azar, filantropia premiável e contravenções penais;{' '}
          <strong>(c)</strong> é o único responsável por obter eventuais autorizações, licenças ou registros
          necessários junto aos órgãos competentes (como a Secretaria de Prêmios e Apostas — SPA, SUSEP ou
          outros aplicáveis);{' '}
          <strong>(d)</strong> a campanha tem caráter de ação entre amigos, fins beneficentes, filantrópicos ou
          sociais, não tendo como objetivo a exploração de jogos de azar;{' '}
          <strong>(e)</strong> será o único responsável por definir corretamente os detalhes da campanha,
          verificar comprovantes de pagamento, realizar o sorteio de forma justa e transparente, e entregar
          o prêmio ao contemplado conforme anunciado;{' '}
          <strong>(f)</strong> é responsável pelas obrigações tributárias e fiscais decorrentes de sua campanha;{' '}
          <strong>(g)</strong> assume integralmente a responsabilidade civil e criminal decorrente de sua campanha.
        </Section>

        <Section title="6. Responsabilidades do Participante">
          Ao participar de uma campanha, o Participante declara que:{' '}
          <strong>(a)</strong> tem pelo menos 18 (dezoito) anos de idade;{' '}
          <strong>(b)</strong> compreende que a transação é realizada diretamente com o Organizador;{' '}
          <strong>(c)</strong> tem conhecimento de que a Plataforma atua apenas como ferramenta tecnológica e
          não garante a entrega de prêmios ou reembolsos;{' '}
          <strong>(d)</strong> fornecerá informações verdadeiras e um endereço de e-mail válido;{' '}
          <strong>(e)</strong> compreende que eventuais disputas devem ser direcionadas diretamente ao
          Organizador da campanha.
        </Section>

        <Section title="7. Pagamentos e Transações Financeiras">
          A RifaMaker <strong>não intermedeia nenhum pagamento</strong> realizado em campanhas. Todos os
          pagamentos são realizados diretamente entre o Participante e o Organizador via PIX ou outro método
          escolhido pelas partes. A Plataforma não processa, retém, armazena ou transfere valores financeiros
          entre as partes. É de responsabilidade do Organizador comprometer-se com os pagamentos realizados
          pelos Participantes e, consequentemente, com reembolsos caso os Participantes solicitem. A Plataforma
          não é responsável por estornos, chargebacks, disputas financeiras ou quaisquer outros problemas
          decorrentes de transações entre Organizadores e Participantes.
        </Section>

        <Section title="8. Sorteios e Resultados">
          Os sorteios podem ser realizados por qualquer método lícito escolhido pelo Organizador (ex.: loteria
          federal, sorteio ao vivo, ferramentas de sorteio online). O Organizador deve fornecer comprovante do
          sorteio ao definir o resultado na Plataforma. A RifaMaker <strong>não realiza sorteios</strong>,
          não valida resultados e <strong>não garante a imparcialidade</strong> dos mesmos. Toda a responsabilidade
          pela condução justa e transparente do sorteio é exclusivamente do Organizador.
        </Section>

        <Section title="9. Limitação de Responsabilidade">
          <strong>A RifaMaker não atua como prestadora de serviço de consultoria ou intermediação entre
          os usuários da Plataforma.</strong> A RifaMaker fornece uma ferramenta tecnológica para que
          Organizadores criem campanhas de ação entre amigos. Assim, a RifaMaker <strong>não é
          responsável</strong> por:{' '}
          danos e prejuízos decorrentes de negócios realizados entre os usuários, sendo estes responsáveis
          por suas próprias ações ou omissões, bem como por eventuais imprecisões, erros e fraudes que possam
          surgir das negociações;{' '}
          a legitimidade, legalidade ou regularidade de campanhas individuais;{' '}
          a entrega de prêmios pelos Organizadores;{' '}
          perdas financeiras decorrentes de participação em campanhas;{' '}
          a veracidade das informações fornecidas pelos usuários;{' '}
          a obtenção de autorizações legais pelo Organizador;{' '}
          indisponibilidade temporária da Plataforma;{' '}
          anúncios de terceiros que induzam a Plataforma a erro.{' '}
          Salvo nos casos de responsabilidade prevista em lei, a RifaMaker não será responsável por quaisquer
          danos de qualquer natureza decorrentes do acesso ou uso do site ou Serviços, sejam patrimoniais ou
          extrapatrimoniais, diretos ou indiretos, incluindo danos emergentes, lucros cessantes ou danos morais.
          A Plataforma é fornecida "como está" (<em>as is</em>), sem garantias de qualquer espécie, expressas
          ou implícitas.
        </Section>

        <Section title="10. Indenização">
          O usuário concorda em indenizar e manter indene a RifaMaker, seus diretores, empregados e agentes
          contra qualquer demanda, prejuízo, perda, despesa ou dano, incluindo honorários advocatícios,
          decorrentes de:{' '}
          <strong>(a)</strong> violação destes Termos;{' '}
          <strong>(b)</strong> violação de qualquer lei ou direito de terceiros;{' '}
          <strong>(c)</strong> uso indevido da Plataforma;{' '}
          <strong>(d)</strong> conteúdo publicado pelo usuário na Plataforma;{' '}
          <strong>(e)</strong> criação ou participação em campanhas ilegais ou não autorizadas.
        </Section>

        <Section title="11. Conduta Proibida">
          É expressamente proibido:{' '}
          <strong>(a)</strong> criar campanhas com finalidade de exploração de jogos de azar ou que configurem
          contravenção penal;{' '}
          <strong>(b)</strong> utilizar a Plataforma para lavagem de dinheiro, financiamento ao terrorismo ou
          qualquer atividade ilícita;{' '}
          <strong>(c)</strong> criar campanhas fraudulentas, enganosas ou que induzam o Participante a erro;{' '}
          <strong>(d)</strong> enviar comprovantes de pagamento falsos ou adulterados;{' '}
          <strong>(e)</strong> criar múltiplas contas para burlar restrições;{' '}
          <strong>(f)</strong> tentar acessar áreas não autorizadas da Plataforma ou manipular seu funcionamento;{' '}
          <strong>(g)</strong> violar direitos de propriedade intelectual de terceiros;{' '}
          <strong>(h)</strong> publicar conteúdo ofensivo, discriminatório, obsceno ou que viole a dignidade humana.
          A RifaMaker se reserva o direito de remover campanhas, suspender ou excluir contas que violem estas
          proibições, sem aviso prévio e sem direito a indenização.
        </Section>

        <Section title="12. Conformidade Legal e Regulatória">
          <strong>É de inteira e exclusiva responsabilidade do Organizador garantir a legalidade e legitimidade
          das atividades que realiza por meio da Plataforma.</strong>{' '}
          No Brasil, a legislação sobre sorteios, rifas e promoções é regulada pela Lei das Contravenções
          Penais (Decreto-Lei nº 3.688/1941), pela Lei nº 5.768/1971, pelo Decreto nº 70.951/1972, pela
          Resolução CNSP nº 384/2020 (SUSEP) e por regulamentações da Secretaria de Prêmios e Apostas (SPA).
          Nos Estados Unidos, as leis sobre raffles variam por estado. O Organizador deve verificar as leis
          de sua jurisdição antes de criar qualquer campanha. A RifaMaker <strong>não presta assessoria jurídica</strong> e
          recomenda fortemente que o Organizador consulte um advogado antes de criar campanhas que envolvam
          sorteios ou distribuição de prêmios. A Plataforma poderá, a seu exclusivo critério, solicitar ao
          Organizador documentação comprobatória de regularidade legal de sua campanha.
        </Section>

        <Section title="13. Propriedade Intelectual">
          Todo o conteúdo da Plataforma, incluindo marca, logotipo, design, código-fonte, funcionalidades e
          documentação, é de propriedade exclusiva da RifaMaker e protegido por leis de propriedade intelectual.
          O uso não autorizado de qualquer material da Plataforma é proibido. O Organizador concede à RifaMaker
          licença não exclusiva para utilizar o conteúdo publicado em suas campanhas exclusivamente para
          fins de operação e divulgação da Plataforma.
        </Section>

        <Section title="14. Suspensão e Cancelamento">
          A RifaMaker pode, a seu exclusivo critério e sem aviso prévio:{' '}
          <strong>(a)</strong> suspender ou encerrar contas que violem estes Termos;{' '}
          <strong>(b)</strong> remover campanhas que apresentem indícios de irregularidade ou ilegalidade;{' '}
          <strong>(c)</strong> restringir funcionalidades da Plataforma para determinados usuários;{' '}
          <strong>(d)</strong> descontinuar a Plataforma, total ou parcialmente, mediante aviso com 30 dias
          de antecedência.{' '}
          A suspensão ou encerramento de conta não exime o Organizador de suas obrigações perante os
          Participantes de suas campanhas.
        </Section>

        <Section title="15. Modificações dos Termos">
          A RifaMaker poderá modificar estes Termos a qualquer momento. Alterações significativas serão
          comunicadas por e-mail ou aviso na Plataforma com pelo menos 15 (quinze) dias de antecedência.
          O uso continuado da Plataforma após a entrada em vigor das alterações constitui aceitação dos
          novos Termos. Caso não concorde com as alterações, o usuário deve cessar imediatamente o uso
          da Plataforma.
        </Section>

        <Section title="16. Disposições Gerais">
          Se qualquer disposição destes Termos for considerada inválida ou inexequível, as demais disposições
          permanecerão em pleno vigor. A tolerância da RifaMaker em relação a qualquer violação destes Termos
          não constituirá renúncia a seus direitos. Estes Termos constituem o acordo integral entre as partes
          em relação ao uso da Plataforma.
        </Section>

        <Section title="17. Legislação Aplicável e Foro">
          Estes Termos são regidos pelas leis da República Federativa do Brasil. Para usuários brasileiros,
          quaisquer disputas serão submetidas ao foro da comarca do domicílio do consumidor, conforme o
          Código de Defesa do Consumidor (Lei nº 8.078/1990). Para usuários internacionais, fica eleito o
          foro da Comarca de São Paulo/SP, salvo legislação imperativa em contrário.
        </Section>

        <Section title="18. Contato">
          Em caso de dúvidas sobre estes Termos, entre em contato conosco através da página de{' '}
          <Link to="/contact" style={{ color: 'var(--primary)' }}>Fale Conosco</Link> ou pelo e-mail{' '}
          <a href="mailto:contato@rifamaker.com.br" style={{ color: 'var(--primary)' }}>contato@rifamaker.com.br</a>.
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <h2 style={{ fontSize: '1.15rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--dark)' }}>{title}</h2>
      <p style={{ margin: 0 }}>{children}</p>
    </div>
  );
}
